<div class="full-page">
  <div class="not-found">Not Found</div>
  <div class="go-back" (click)="goBack()">返回</div>
</div>
